import { LogErrors } from './../../LogErrors'

import { DoubleAttempt } from './../Helpers/DoubleAttempt'


const rolesData = {
    ZTUDIANTE: 1,
    INSTRUCTOR: 2,
    LEADER: 3
}

// const RequestToAPI = async (url, parameters) => {
//     try {
//         const response = await fetch(url, parameters)

//         if (!response.ok) {
//             // Manejar errores HTTP
//             const errorData = await response.json()
            
//             const messageId = errorData.messageId
            
//             if (!messageId) {
//                 // Sí se recibió un error 102 del server, avisar que se debe reintentar
//                 if (messageId === 102) {
//                     return { success: false, message: '', retry: true }
//                 }
//             } else {
//                 //return { success: false, message: errorData.message || 'Error de autenticación' }
//                 return { success: false, message: errorData.message } //errorCode
//             }
//         }
        
//         const data = await response.json()
        
//         // Retornar la respuesta exitosa
//         return { success: true, data: data }
//     } catch (error) {
//         await LogErrors('RequestToAPI DL Courses', error)
//         return { success: false, message: '' }
//     }
// }

// const DoubleAttempt = async (url, parameters) => {
//   try {
//     const response = await RequestToAPI(url, parameters)
    
//     if (response.success) {
//         //console.log("1er intento")
//         return { success: true, data: response.data }
//     } else {
//         const retry = response.retry

//         if (retry) {
//             const responseRetry = await RequestToAPI(url, parameters)

//             if (responseRetry.success) {
//                 //console.log("2do intento")
//                 return { success: true, data: responseRetry.data }
//             } else {
//                 return { success: false, message: responseRetry.message}
//             }
//         } else {
//             return { success: false, message: response.message }
//         }
//     }
//   } catch (error) {
    
//   }
// }

/**
 * Realiza la llamada a la API para obtener los cursos del usuario
 * @returns {Object} Resultado del proceso { success: boolean, data: Object, message: string }
 */
const GetCourses = async (token, centerSelected, roleSelected) => {
  try {
    const dataToSend = {
      "user": {
        "center": {
          "id": centerSelected
        },
        "role": {
          "id": roleSelected
        }
      }
    }
    
    const parameters = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      },
      body: JSON.stringify(dataToSend)
    }
    
    const url = process.env.REACT_APP_API_URL + '/api/Api/ZtudianteMyCourses'


    const response = await DoubleAttempt(url, parameters)

    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response?.message }
    }

    //const response = await fetch(process.env.REACT_APP_API_URL + '/api/Api/ZtudianteMyCourses', parameters)

    // if (!response.ok) {
    //   // Manejar errores HTTP
    //   const errorData = await response.json()
    //   return { success: false, message: errorData.errorCode }
    // }

    // const data = await response.json()

    // // Retornar la respuesta exitosa
    // return { success: true, data: data }
  } catch (error) {
    await LogErrors('GetCourses - Courses DL', error)
    //return { success: false, message: 'errorNetwork' } // Código genérico para errores de red
    return { success: false, message: 'No ha sido posible obtener tus cursos. Actualiza la página o intenta actualizarla más tarde' }
  }
}

const GetChoosenCourse = async (token, idCourse, idCenter, role = rolesData.ZTUDIANTE, idInstructor = null) => {
  try {
    let url = null

    let dataToSend = {
      idCenter: idCenter,
      idCourse: idCourse
    }

    if (role === rolesData.ZTUDIANTE) {
      url = process.env.REACT_APP_API_URL + '/api/V4/Api/chosencourse'
    } else if (role === rolesData.INSTRUCTOR) {
      url = process.env.REACT_APP_API_URL + '/api/V2/Api/ChosenCourseInstructors'
    } else if (role === rolesData.LEADER) {
      // El Líder consulta el curso de un Instructor al que hace referencia,
      // por eso este endpoint exige el rol y el IdInstructor de forma explícita.
      url = process.env.REACT_APP_API_URL + '/api/V5/Reports/ChosenCourseReports'
      dataToSend = {
        IdCenter: idCenter,
        IdCourse: idCourse,
        IdUserRol: role,
        IdInstructor: idInstructor
      }
    }

    if (!url) {
      return { success: false, message: `No ha sido posible obtener la información del curso.` }
    }

    const parameters = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        body: JSON.stringify(dataToSend)
    }

    const response = await DoubleAttempt(url, parameters)

    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response?.message }
    }

    // const response = await fetch(url, { //process.env.REACT_APP_API_URL + /api/Api/ChosenCourse
    //     method: 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': token
    //     },
    //     body: JSON.stringify(dataToSend)
    // })
    
    // if (!response.ok) {
    //     // Manejar errores HTTP
    //     const errorData = await response.json()
    //     //return { success: false, message: errorData.message || 'Error de autenticación' }
    //     return { success: false, message: errorData.message } //errorData.errorCode
    // }
    
    // const data = await response.json()
    
    // // Retornar la respuesta exitosa
    // return { success: true, data: data }
  } catch (error) {
    await LogErrors('GetChoosenCourse - Courses DL', error)
    return { success: false, message: 2 }
  }
}

/**
 * Consulta si el Ztudiante ya utilizó una licencia para este curso.
 * IdStudent se ignora del lado del backend: el Gateway lo deriva del token.
 */
const ValidateLicense = async (token, idCenter, idCourse) => {
  try {
    const dataToSend = {
      IdCenter: idCenter,
      IdRol: rolesData.ZTUDIANTE,
      IdCourse: idCourse
    }

    const parameters = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      },
      body: JSON.stringify(dataToSend)
    }

    const url = process.env.REACT_APP_API_URL + '/api/V5/Users/ValidateLicense'
    const response = await DoubleAttempt(url, parameters)

    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response?.message }
    }
  } catch (error) {
    await LogErrors('ValidateLicense - Courses DL', error)
    return { success: false, message: `No ha sido posible validar la licencia del curso.` }
  }
}

/**
 * Registra el uso de una licencia para este curso. Escribe de forma permanente: si el
 * Ztudiante ya la había usado antes, el backend responde 409.
 */
const UseInstructorLicense = async (token, idCenter, idCourse) => {
  try {
    const dataToSend = {
      IdCenter: idCenter,
      IdRol: rolesData.ZTUDIANTE,
      IdCourse: idCourse
    }

    const parameters = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      },
      body: JSON.stringify(dataToSend)
    }

    const url = process.env.REACT_APP_API_URL + '/api/V5/Users/UseInstructorLicense'
    const response = await DoubleAttempt(url, parameters)

    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response?.message }
    }
  } catch (error) {
    await LogErrors('UseInstructorLicense - Courses DL', error)
    return { success: false, message: `No ha sido posible activar la licencia.` }
  }
}

/**
 * Consulta si el centro está en modalidad de licencias gratuitas ("isFreeLicenses").
 * Se usa en el dashboard del Ztudiante para decidir si al entrar a un curso debe
 * correr el flujo de ValidateLicense/UseInstructorLicense (isFreeLicenses === false)
 * o si puede entrar directo (isFreeLicenses === true).
 */
const GetCenterFreeLicensesStatus = async (token, idCenter) => {
  try {
    const dataToSend = {
      IdCenter: idCenter,
      IdUserRol: rolesData.ZTUDIANTE
    }

    const parameters = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      },
      body: JSON.stringify(dataToSend)
    }

    const url = process.env.REACT_APP_API_URL + '/api/V5/Users/GetCenterFreeLicensesStatus'
    const response = await DoubleAttempt(url, parameters)

    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response?.message }
    }
  } catch (error) {
    await LogErrors('GetCenterFreeLicensesStatus - Courses DL', error)
    return { success: false, message: `No ha sido posible consultar el estado de licencias gratuitas del centro.` }
  }
}

const ValidateNumberOfExamsTaken = async (token, idCenter, idCourse, idItem) => {
  try {
    const dataToSend = {
      "idCenter": idCenter,
      "idCourse": idCourse,
      "idItem": idItem
    }
    
    const parameters = {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': token
      },
      body: JSON.stringify(dataToSend)
    }

    const url = process.env.REACT_APP_API_URL + "/api/V2/Api/ValidateNumberOfExamsTaken"

    const response = await DoubleAttempt(url, parameters)

    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response?.message }
    }

    // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/ValidateNumberOfExamsTaken", {
    //     method: 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': token
    //     },
    //     body: JSON.stringify(dataToSend)
    // })
    
    // if (!response.ok) {
    //     // Manejar errores HTTP
    //     const errorData = await response.json()
    //     //return { success: false, message: errorData.message || 'Error de autenticación' }
    //     return { success: false, message: errorData.message } //errorData.errorCode
    // }
    
    // const data = await response.json()
    
    // // Retornar la respuesta exitosa
    // return { success: true, data: data }
  } catch (error) {
    await LogErrors('ValidateNumberOfExamsTaken - Courses DL', error)
    return { success: false, message: 'No ha sido posible validar la evaluación. Inténtalo nuevamente o inténtalo más tarde' }
  }
}

const GetCourseProgress = async (idCenter, idCourse, token) => {
  try {
    const dataToSend = {
      idCenter: idCenter,
      idCourse: idCourse
    }
    
    const parameters = {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': token
      },
      body: JSON.stringify(dataToSend)
    }

    const url = process.env.REACT_APP_API_URL + "/api/V2/Api/GetCourseProgress"

    const response = await DoubleAttempt(url, parameters)

    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response?.message }
    }

    // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/GetCourseProgress", {
    //     method: 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': token
    //     },
    //     body: JSON.stringify(dataToSend)
    // })
    
    // if (!response.ok) {
    //     // Manejar errores HTTP
    //     const errorData = await response.json()
    //     //return { success: false, message: errorData.message || 'Error de autenticación' }
    //     return { success: false, message: errorData.message } //errorData.errorCode
    // }
    
    // const data = await response.json()
    
    // // Retornar la respuesta exitosa
    // return { success: true, data: data }
  } catch (error) {
    await LogErrors('GetCourseProgress - Courses DL', error)
    return { success: false, message: 'No hay sido posible obtener el avance del curso' }
  }
}

const GetCourseProgressInstructor = async (idCenter, idCourse, idUser, token) => {
  try {
    const dataToSend = {
      idCenter: idCenter,
      idCourse: idCourse,
      idUser: idUser
    }

    const parameters = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        body: JSON.stringify(dataToSend)
    }
    
    const url = process.env.REACT_APP_API_URL + "/api/V2/Api/GetCourseProgressPanelInstructor"

    const response = await DoubleAttempt(url, parameters)

    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response?.message }
    }

    // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/GetCourseProgressPanelInstructor", {
    //     method: 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': token
    //     },
    //     body: JSON.stringify(dataToSend)
    // })
    
    // if (!response.ok) {
    //     // Manejar errores HTTP
    //     const errorData = await response.json()
    //     //return { success: false, message: errorData.message || 'Error de autenticación' }
    //     return { success: false, message: errorData.message } //errorData.errorCode
    // }
    
    // const data = await response.json()
    
    // // Retornar la respuesta exitosa
    // return { success: true, data: data }
  } catch (error) {
    await LogErrors('GetCourseProgressInstructor - Courses DL', error)
    return { success: false, message: 'No hay sido posible obtener el avance del curso' }
  }
}

export { GetCourses, GetChoosenCourse, ValidateLicense, UseInstructorLicense, ValidateNumberOfExamsTaken, GetCourseProgress, GetCourseProgressInstructor, GetCenterFreeLicensesStatus };